import React, { Component } from 'react';
import { Grid, Divider, Tab } from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import Route from './tabs/route-tab';
import Ownership from './tabs/owner-load-limits/ownership';
import LoadLimits from './tabs/owner-load-limits/load-limits';
import '../index.css';

export default class OwnerLoadLimits extends Component {

    constructor(props)
    {
        super(props);

        if (this.props.loadData) {
            this.state = {
                OwnerLoadLimits: this.props.loadData
            };
        }
        else {
            // This is a super data model class, its main function is to collect data from all the children components.
            this.state = {
                OwnerLoadLimits: {
                    layer: 2,
                    layerName: 'OwnerLoadLimits',
                    layerId: -1,
                    agencyId: -1, //to be determined later

                    route: {
                        id: -1, //id is not set, will be setting it soon.
                        start: '0,0',
                        end: '0,0',
                        isPolyLine: false,
                        waypoints: [],
                        routeLine: null,
                        hwyNum: "",
                        segDesc: ""
                    },

                    ownership: {
                        owner: 0,
                        functionalClass: 0,
                        maintenance: 0,
                        roadwayType: 0
                    },

                    loadLimits: {
                        seasonalLoadLimit: 0,
                        seasonalGrossWeight: 0,
                        yearRoundLoadLimit: 0,
                        yearRoundGrossWeight: 0,
                        assignedZone: 999
                    }
                }
            };
        }

        this.panes = [
            {
                menuItem: 'Location', render: () =>
                    <Tab.Pane>
                        <Route clickFunctions={this.props.clickFunctions}
                            trackLocationChanged={this.props.isLocationChanged}
                            triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            routeModel={this.state.OwnerLoadLimits.route} layername={this.state.OwnerLoadLimits.layerName}/>
                    </Tab.Pane>
            },
            {
                menuItem: 'Ownership', render: () =>
                    <Tab.Pane>
                        <Ownership triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                        ownModel={this.state.OwnerLoadLimits} />
                    </Tab.Pane>
            },
            {
                menuItem: 'LoadLimits', render: () =>
                    <Tab.Pane>
                        <LoadLimits triggerNeedSave={this.props.triggerNeedSave}
                            disabled={this.props.disabled}
                            ownModel={this.state.OwnerLoadLimits} />
                    </Tab.Pane>
            },
        ];

        this.props.dataModel.splice(0, this.props.dataModel.length);
        this.props.dataModel.push(this.state.OwnerLoadLimits);
    }

    renderGritLayerUI = () => {
        return (
            <div>
                {/* <Grid.Row>
                    <h5>Owner/Load Limits</h5>
                </Grid.Row> */}
                <Divider style={{ marginTop: -3 }} />
                <Grid.Row>
                    <Tab panes={this.panes} activeIndex={this.props.activeIndex} onTabChange={this.onTabChange} />
                </Grid.Row>
            </div>
        );
    }

    onTabChange = (e, data) => {
        this.props.updateActiveIndex(data.activeIndex);
    }

    render() {
        return this.renderGritLayerUI();
    }
}


// WEBPACK FOOTER //
// ./src/layers/owner-load-limits.js